var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.smAndDown)?_c('p',{staticClass:"mt-2 mb-0 body-1 font-weight-medium text-center"},[_vm._v(_vm._s(_vm.dateLabel))]):_vm._e(),_c('telemetrie-graph-grid')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }